import * as messageService from "../../services/message.service";
import * as reportService from '../../services/report.service';


const state = {
    reportInputs:{},
};

const getters = {
    getReportInputs:state => (state.reportInputs),
};

const actions = {

    fetchReportInputs({ commit }, obj ){
        commit('setReportInputs', obj);
    },
};

const mutations = {
    setReportInputs:(state, res) => (
        state.reportInputs =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}